import { Button } from '@stone-payments/jade'

import BlackBird from '~/domains/platform/lib/blackbird'

import { analitica } from '../../analitica'

export function ChatWhatsAppSupportButton() {
  const queries = BlackBird.getQuery()
  const tenant = queries.tenant as 'ton' | 'stone' | undefined

  const redirectToWhatsApp = (link: string) => {
    window.open(link, '_blank')
  }

  const handleClickWhatsApp = () => {
    analitica.events.chatEvents.buttonClicked({ screen: BlackBird.getPathname(), reference: 'Botão WhatsApp' })
    if (tenant === 'ton') {
      redirectToWhatsApp(
        'https://click.relacionamento.ton.com.br/?qs=544f2b08ac40c4a4ca6e8e3360fb167735dbf350bc7a4e06fbd7fe96f2fefbe6c086cb1440049d6dbdf468178840e1d3c348ccd241a7729c707eb0f6f69eaf97'
      )
      return
    }
    redirectToWhatsApp(
      'https://api.whatsapp.com/send?phone=551130049680&text=Oi,%20voc%C3%AA%20poderia%20me%20ajudar?%20'
    )
  }

  return (
    <Button variant="neutral-subtle" size="medium" onClick={handleClickWhatsApp} icon="brand-whatsapp">
      Atendimento
    </Button>
  )
}
